// extracted by mini-css-extract-plugin
module.exports = {"container":"SuppliersTab_container__39uZP"};